import styled from 'styled-components';
import { Text } from '@acko-tech/building-blocks.ui.typography';

export const MainHeading = styled(Text)`
  color: var(--text-primary-n-600, #040222);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.1px;
  color: #040222;
  margin-bottom: 12px;
  text-align: left; 
`;

export const SubHeading = styled(Text)`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #5B5675;
  margin-bottom: 12px;
  text-align: left;
`;

export const HowItWorksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: left;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const StepNumber = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 48px;
  background: var(--background-primary-n-100, #F0F0F6);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #040222; 
  flex-shrink: 0; 
`;

export const ListItemText = styled(Text)`
  font-size: 14px;
  line-height: 20px;
  font-weight:400;
  color: #040222;
  flex-grow: 1; 
  align-self: stretch;
  margin-top: 5px;
`;